/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import {
  LegacyAudioPlayer,
  StreamingAudioPlayer,
  AudioPlayer,
} from "AudioPlayer";
import store from "reducers/Store";
import { shouldUseStreamingPlayer } from "selectors/PlayerSelector";

let _audioPlayer: AudioPlayer | null = null;

export const getAudioPlayerInstance = (override?: boolean): AudioPlayer => {
  const streaming = override ?? shouldUseStreamingPlayer(store.getState());

  if (!_audioPlayer) {
    if (!streaming) {
      newrelic.addPageAction("CREATING_NEW_LEGACY_AUDIO_PLAYER");
      _audioPlayer = new LegacyAudioPlayer();
    } else {
      newrelic.addPageAction("CREATING_NEW_STREAMING_AUDIO_PLAYER");
      console.log("Creating new StreamingAudioPlayer instance ---------");
      _audioPlayer = new StreamingAudioPlayer();
    }
  } else if (_audioPlayer instanceof LegacyAudioPlayer && streaming) {
    newrelic.addPageAction("SWITCHING_TO_STREAMING_AUDIO_PLAYER");
    _audioPlayer.reset();
    _audioPlayer = new StreamingAudioPlayer();
  } else if (_audioPlayer instanceof StreamingAudioPlayer && !streaming) {
    newrelic.addPageAction("SWITCHING_TO_LEGACY_AUDIO_PLAYER");
    _audioPlayer.reset();
    _audioPlayer = new LegacyAudioPlayer();
  }
  return _audioPlayer;
};

export const resetAudioPlayerInstance = async (): Promise<void> => {
  await _audioPlayer?.reset();
  _audioPlayer = null;
};

export default getAudioPlayerInstance;
